import { CircularProgress } from '@material-ui/core'
import { Theme } from '@material-ui/core/styles'
import { makeStyles } from '@material-ui/styles'
import React from 'react'
import { ErrorMessage } from 'core/components/validatedForm/ErrorMessage'
import Button from 'core/elements/button'
import Modal from 'core/elements/modal'
import Text from 'core/elements/Text'

const useStyles = makeStyles<Theme>((theme) => ({
  progressContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  message: {
    margin: theme.spacing(2, 0),
  },
}))

interface VmConsoleLoadingDialogProps {
  open: boolean
  onClose: () => void
  error?: string | null
  loading: boolean
  vmName?: string
}

const VmConsoleLoadingDialog: React.FC<VmConsoleLoadingDialogProps> = ({
  open,
  onClose,
  error,
  loading,
  vmName = 'the VM',
}) => {
  const classes = useStyles()
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="VM Console"
      panel="dialog"
      footer={
        error ? (
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        ) : null
      }
    >
      <>
        {loading && (
          <div className={classes.progressContainer}>
            <CircularProgress size={20} />
            <Text variant="body2">
              Connecting to VM console for <b>{vmName}</b>
            </Text>
          </div>
        )}
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </>
    </Modal>
  )
}

export default VmConsoleLoadingDialog
